import { useRoutes} from "react-router-dom";
import Xroutes from "./routers";
const App = () => {
  let element = useRoutes(Xroutes);
  return element;
};

export default App;
